// JsonField.js
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Wrapper, Label } from '../SharedStyles.element'
import { JsonEditorTextarea, ErrorText } from './JsonField.elements'

function JsonField({ id, label, disabled, initialValue, onChange, rows }) {
  const [value, setValue] = useState()
  const [error, setError] = useState('')

  const handleChange = (e) => {
    const text = e.target.value
    setValue(text)
    onChange(text)

    try {
      JSON.parse(text)
      setError('')
    } catch {
      setError('Invalid JSON')
    }
  }

  useEffect(() => {
    if (initialValue && Object.keys(initialValue).length > 0 && !value) {
      setValue(JSON.stringify(initialValue, null, 2))
    }
  }, [initialValue])
  return (
    <Wrapper label={label}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <JsonEditorTextarea
        rows={rows}
        id={id}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        error={!!error}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  )
}

JsonField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  rows: PropTypes.string,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
}

JsonField.defaultProps = {
  id: '',
  label: '',
  rows: '5',
  disabled: false,
  initialValue: {},
  onChange: () => {},
}

export default JsonField
